<template>
  <div class="case-study-card">
    <div class="case-study-card__header">
      <div class="case-study-card__brand">
        <img
          :src="require(`@/assets/${image}`)"
          :alt="alt"
          class="case-study-card__logo"
        />
      </div>
      <h3 class="case-study-card__title">{{ title }}</h3>
    </div>

    <div class="case-study-card__section">
      <div class="case-study-card__label case-study-card__label--problem">
        Problem
      </div>
      <p class="case-study-card__text">{{ problem }}</p>
    </div>

    <div class="case-study-card__section">
      <div class="case-study-card__label case-study-card__label--solution">
        Solution
      </div>
      <p class="case-study-card__text">{{ solution }}</p>
    </div>

    <div class="case-study-card__section">
      <div class="case-study-card__label case-study-card__label--outcome">
        Outcome
      </div>
      <p class="case-study-card__text">{{ outcome }}</p>
      <div v-if="roas || profitMargin" class="case-study-card__metrics">
        <div v-if="roas" class="case-study-card__metric">
          <span class="case-study-card__metric-value">{{ roas }}</span>
          <span class="case-study-card__metric-label">ROAS</span>
        </div>
        <div v-if="profitMargin" class="case-study-card__metric">
          <span class="case-study-card__metric-value">{{ profitMargin }}</span>
          <span class="case-study-card__metric-label">Net Profit Margin</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressCard",
  props: {
    title: {
      type: String,
      required: true,
    },
    problem: {
      type: String,
      required: true,
    },
    solution: {
      type: String,
      required: true,
    },
    outcome: {
      type: String,
      required: true,
    },
    roas: {
      type: String,
      default: "",
    },
    profitMargin: {
      type: String,
      default: "",
    },
    image: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.case-study-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 32px;
  margin-bottom: 24px;

  &__header {
    margin-bottom: 32px;
    padding-bottom: 16px;
    border-bottom: 2px solid #f0f0f0;
    display: flex;
    align-items: center;
    gap: 20px;
  }

  &__brand {
    flex-shrink: 0;
  }

  &__logo {
    width: 100px;
    height: 100px;
    object-fit: contain;
    border-radius: 12px;
  }

  &__title {
    font-size: 24px;
    font-weight: 700;
    color: #584f49;
    margin: 0;
    line-height: 1.3;
    flex: 1;
  }

  &__section {
    margin-bottom: 28px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__label {
    display: inline-block;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1px;
    padding: 8px 16px;
    border-radius: 20px;
    margin-bottom: 12px;

    &--problem {
      background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
      color: #dc2626;
    }

    &--solution {
      background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
      color: #2563eb;
    }

    &--outcome {
      background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
      color: #059669;
    }
  }

  &__text {
    font-size: 16px;
    line-height: 1.6;
    color: #4a5568;
    margin: 0;
  }

  &__metrics {
    display: flex;
    gap: 24px;
    margin-top: 20px;
    flex-wrap: wrap;
  }

  &__metric {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    padding: 16px 24px;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    min-width: 120px;
  }

  &__metric-value {
    font-size: 28px;
    font-weight: 800;
    color: #059669;
    line-height: 1;
    margin-bottom: 4px;
  }

  &__metric-label {
    font-size: 12px;
    font-weight: 500;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    text-align: center;
  }
}

@media (max-width: 768px) {
  .case-study-card {
    padding: 24px 20px;
    margin-bottom: 20px;

    &__header {
      flex-direction: column;
      text-align: center;
      gap: 16px;
    }

    &__logo {
      width: 80px;
      height: 80px;
    }

    &__title {
      font-size: 20px;
    }

    &__text {
      font-size: 15px;
    }

    &__metrics {
      gap: 16px;
      justify-content: center;
    }

    &__metric {
      min-width: 100px;
      padding: 12px 16px;
    }

    &__metric-value {
      font-size: 24px;
    }
  }
}
</style>
